/**
 * "Oyda bosqich" filtri (2026-10-28, foydalanuvchi: bosh sahifadan kelgan "Hired in Oct 2026" kabi filtrni qo'lda qo'yib bo'lmasdi).
 * Bitta tanlov -- bosqich va oy; URL kalitlari backend filtrlari bilan bir xil (`apps/drivers/filters.py`):
 * yangi -- `added_month` (qo'shilgan), yuborilgan -- `submitted_month`, ishga olingan -- `hired_month` (tasdiqlangan),
 * yo'qotilgan -- `lost_month`, qolgan bosqichlar -- `reached_status` + `reached_month` (status tarixi). Test: stageMonth.test.ts.
 */
import { dayjs } from "@/lib/utils";
import { PIPELINE_ORDER, type DriverStatus } from "./types";

export type StageEvent = DriverStatus | "lost";

export const STAGE_EVENTS: StageEvent[] = [...PIPELINE_ORDER, "lost"];

export const STAGE_MONTH_KEYS = ["added_month", "submitted_month", "hired_month", "lost_month", "reached_status", "reached_month"] as const;

const OWN_KEY: Partial<Record<StageEvent, (typeof STAGE_MONTH_KEYS)[number]>> = {
  new: "added_month",
  submitted: "submitted_month",
  hired: "hired_month",
  lost: "lost_month",
};

const MONTH = /^\d{4}-\d{2}$/;

/** URL'dagi filtr: { bosqich, oy } yoki null */
export function readStageMonth(get: (key: string) => string): { event: StageEvent; month: string } | null {
  for (const [event, key] of Object.entries(OWN_KEY) as [StageEvent, string][]) {
    if (MONTH.test(get(key))) return { event, month: get(key) };
  }
  const status = get("reached_status") as DriverStatus;
  if (PIPELINE_ORDER.includes(status) && MONTH.test(get("reached_month"))) return { event: status, month: get("reached_month") };
  return null;
}

/** URL o'zgarishi: boshqa kalitlar tozalanadi, tanlanganiga mos kalit qo'yiladi; bosqich bo'sh -- filtr yo'q */
export function stageMonthPatch(event: StageEvent | "", month: string): Record<string, string | null> {
  const patch: Record<string, string | null> = Object.fromEntries(STAGE_MONTH_KEYS.map((k) => [k, null]));
  if (!event) return patch;
  const own = OWN_KEY[event];
  if (own) patch[own] = month;
  else Object.assign(patch, { reached_status: event, reached_month: month });
  return patch;
}

/** Ro'yxat havolasi (bosh sahifa, hisobot): `/drivers?<bosqich+oy>&<qo'shimcha filtrlar>` */
export function stageMonthLink(event: StageEvent, month: string, extra: Record<string, string | number | undefined | null> = {}): string {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(stageMonthPatch(event, month))) if (v) q.set(k, v);
  for (const [k, v] of Object.entries(extra)) if (v !== undefined && v !== null && v !== "") q.set(k, String(v));
  return `/drivers?${q.toString()}`;
}

/** Tanlov uchun oylar: joriy oydan orqaga `count` ta ("YYYY-MM"); URL'dagi eskiroq oy ham ro'yxatda qoladi */
export function recentMonths(count = 24, keep?: string, now = dayjs()): string[] {
  const out = Array.from({ length: count }, (_, i) => now.startOf("month").subtract(i, "month").format("YYYY-MM"));
  if (keep && MONTH.test(keep) && !out.includes(keep)) out.push(keep);
  return out;
}
